import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'components/library';
import { LocaleString } from '@biw/intl';
import './session-modal.scss';
import isEqual from 'lodash/isEqual';

import * as utils from 'utils/browser';

export default class SessionModal extends React.Component {

    static propTypes = {
        logout: PropTypes.func.isRequired,
        setSessionExtend: PropTypes.func.isRequired,
        extendSession: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired
    };

    state = {
        sessionModalOpen: true
    }

    componentDidUpdate( prevProps ) {
        if ( !isEqual( prevProps.session.status, this.props.session.status ) ) {
            const isInvalidRoute = this.checkForInvalidRoute();
            const isSessionValid = this.checkIfValidSession( this.props.session.status );

            if ( !isSessionValid && !isInvalidRoute ) {
                this.props.logout();
            }
        }
    }

    checkForInvalidRoute = () => {
        const pathname = utils.getLocationPathname();
        return pathname === '/login' || pathname === '/' || pathname === '/logout' ? true : false;
    }

    checkIfValidSession = ( status ) => {
        return status === 'end' ? false : true;
    }

    checkForInvalidRoute = () => {
        const pathname = utils.getLocationPathname();
        return pathname === '/login' || pathname === '/' || pathname === '/logout' ? true : false;
    }


    checkIfValidSession = ( status ) => {
        return status === 'end' ? false : true;
    }

    openModal = event => this.setState( { sessionModalOpen: true } );

    reAuthenticate = ( event ) => {
        this.setState( { sessionModalOpen: false } );
        this.props.setSessionExtend();
        this.props.extendSession();
    }

    unAuthenticate = () => {
        this.setState( { sessionModalOpen: false } );
        this.props.logout();
    }

    render() {
        const isInvalidRoute = this.checkForInvalidRoute();
        const isSessionValid = this.checkIfValidSession( this.props.session.status );
        const modalStatus = this.props.session.status === 'warning' && !isInvalidRoute ? true : false;
        // Session timeout loop ends here
        if ( !isSessionValid && isInvalidRoute ) {
            return null;
        }

        return (
            <Modal
                className="session-modal"
                isOpen={ modalStatus }
                onClose= { this.reAuthenticate }
                closable
            >
                <h3><LocaleString code="session.inactiveHeading"/></h3>
                <p><LocaleString code="session.inactiveMessage"/></p>
                <div className="button-wrapper">
                    <a href="#" className="gq-btn client-primary-button" tabIndex="" onClick={ this.reAuthenticate } >
                        <LocaleString code="session.extendSession"/>
                    </a>
                    <a href="#" className="gq-btn client-primary-button" tabIndex="" onClick={ this.unAuthenticate } ><LocaleString code="session.logout"/></a>
                </div>
            </Modal>
        );
    }
}
